import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Icons } from "../../../config/MuiIcons.config";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import WarningImage from "../../../assets/images/Warning.svg";

const WarningModalForThirdPartyFinalSave = ({
  Open,
  ToggleFunction,
  OnSubmit,
  Data,
  Type,
}) => {

  const warning_message =
    Type === "FINAL_SAVE"
      ? "Are you sure do you want to mark this audit as 'Completed'?"
      : "You are about to finalize your response and submit it for review. Once submitted, no further changes can be made at this stage.";

  const handleClose = () => {
    ToggleFunction();
  };

  return (
    <React.Fragment>
      <Dialog
        open={Open}
        aria-labelledby="form-dialog-title"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle style={{ textAlign: "center" }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <Icons.Close />
          </IconButton>
          <img
            src={WarningImage}
            alt="warning-img"
            style={{ width: "45px", height: "45px" }}
          />
        </DialogTitle>
        <DialogContent style={{ textAlign: "center" }}>
          <Typography
            style={{ fontSize: "24px" }}
            className="inter-regular-400"
          >
            {Type === "FINAL_SAVE"
              ? "Are you sure?"
              : "Are you sure you want to proceed?"}
          </Typography>
          <Typography
            className="inter-regular-400"
            style={{ fontSize: "16px" }}
          >
            {warning_message}
          </Typography>
        </DialogContent>
        <DialogActions className="justify-content-center mb-3 mx-5">
          <AppButton Color={"error"} OnPress={handleClose}>
            Cancel
          </AppButton>
          <AppButton
            OnPress={() => {
              OnSubmit(Data, Type);
              handleClose();
            }}
          >
            Submit
          </AppButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default WarningModalForThirdPartyFinalSave;
